/**
 * 근태 요약(일자별) 쿼리 키 팩토리.
 *
 * 소비처가 `features/worklog`(조회) · `features/check-in`(무효화) ·
 * `pages/AdminAttendancePage`(휴가 부여 후 무효화)로 **세 슬라이스에 퍼져 있어**
 * entity 레이어에 둔다.
 *
 * ⚠️ `attendanceKeys`(루트 `attendances`)와 **별개 루트**다. 근태 레코드 무효화가 이 요약을
 * 건드리지 않고, 그 반대도 마찬가지다 — 기존 구조를 그대로 지켰다.
 *
 * 회귀 가드: `__tests__/attendanceSummaryKeys.test.ts`.
 */
import { defineQueryKeys } from '@/shared/lib/queryKeys';

export const attendanceSummaryKeys = defineQueryKeys('attendanceSummary', (all) => ({
  byDate: (date: string | undefined) => [...all, date] as const,
}));
